<template>
  <div>
    <div class="row tight">
      <div class="col-2 text-center" v-if="canEdit">
        <a @click="increase('current')" class="plus-minus"><i class="fa fa-plus-circle"></i></a><br>
        <a @click="decrease('current')" class="plus-minus"><i class="fa fa-minus-circle"></i></a>
      </div>
      <div class="col">
        <under-text class="text-center">
          <span slot="underline">
            {{dying.current}}
          </span>
          Dying
        </under-text>
      </div>
      <div class="col">
        <under-text class="text-center">
          <span slot="underline">
            {{dying.wounds}}
          </span>
          Wounds
        </under-text>
      </div>
      <div class="col-2 text-center" v-if="canEdit">
        <a @click="increase('wounds')" class="plus-minus"><i class="fa fa-plus-circle"></i></a><br>
        <a @click="decrease('wounds')" class="plus-minus"><i class="fa fa-minus-circle"></i></a>
      </div>
    </div>

  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "big-boxes-hit-dice",
  components: {
    EzModalDice,
    UnderInput,
    UnderText
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    ...mapState({
      dying: state => state.characters.current.defense.dying
    })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    decrease(hp) {
      if (!Number.isFinite(this.dying[hp])) this.dying[hp] = 0;

      this.dying[hp] -= 1;

      if (this.dying[hp] < 0) {
        this.dying[hp] = 0;
      }
      this.autoSave();
    },
    increase(hp) {
      if (!Number.isFinite(this.dying[hp])) this.dying[hp] = 0;
      if (hp == "current" && this.dying[hp] < 4) {
        this.dying[hp] += 1;
      }
      if (hp == "wounds" && this.dying[hp] < 3) {
        this.dying[hp] += 1;
      }
      this.autoSave();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";

h5 {
  border-bottom: 2px solid $gray-400;
  margin: 0.25em 0;
  text-align: center;
}

.plus-minus {
  font-size: 1.25em;
  line-height: 0.5em;
}
</style>
